import React from 'react'
import cx from 'classnames'
import { t } from 'ttag'

import { MessageAlert } from 'components/shared/Alerts/MessageAlert/MessageAlert'
import { Modal } from 'components/shared/Modal/Modal'

import styles from './SelectResourceModal.module.scss'

type SelectResourceModalProps = {
  alert?: React.ReactNode
  className?: string
  message?: React.ReactNode
  title?: string
  onCancel: () => void
  onClose: () => void
  onConfirm: () => void
  isOpen: boolean
}

export const SelectResourceModal = ({
  alert,
  className = undefined,
  message,
  title,
  onCancel,
  onClose,
  onConfirm,
  isOpen,
}: SelectResourceModalProps) => (
  <Modal
    className={cx(styles.modal, className)}
    cancelLabel={t`Cancel`}
    confirmLabel={t`Confirm`}
    {...{ title, onCancel, onClose, onConfirm, isOpen }}
  >
    <Modal.Header />
    <Modal.Content className={styles.content}>
      <MessageAlert
        className={styles.alert}
        message={alert}
        variant="warning"
        isInitialised
      />
      <p className={styles.text}>{message}</p>
    </Modal.Content>
    <Modal.Footer />
  </Modal>
)
